<script>
import Notification from "@/components/reUse/Notification.vue";

export default {
  name: "Changelog",
  components: {Notification},
  data() {
    return {
      vnosi: [],
      verzija: '',
      datumSpremembe: null,
      naslovSpremembe: '',
      tipSpremembe: 'novo',
      idIzbrisa: null,
      opis: null,
      oznake: null,
      text: '',
      types: '',
      ShowNoti: false,
      vnasam: false,
      berem: false,
    }
  },
  mounted() {
    this.BeriVnose();
  },
  methods: {
    BeriVnose() {
      this.berem = true;
      axios.get('./api/changelog/v2/izpis/', {withCredentials: true}).then((response) => {
        this.vnosi = response.data.podatki;
        this.berem = false;
      }).catch((napaka) => {
        this.berem = false;
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if(napaka.response.data.napaka) {
          this.types = "Napaka";
          this.text = napaka.data.response.napaka;
          this.ShowNoti = true;
        }else {
          this.types = "Napaka";
          this.text = "Prišlo je do napake";
          this.ShowNoti = true;
        }

      });
    },
    DodajVnos() {
      this.vnasam = !this.vnasam;
      let podatki = new URLSearchParams();
      podatki.append('verzija', this.verzija);
      podatki.append('datum', this.datumSpremembe);
      podatki.append('naslov', this.naslovSpremembe);
      podatki.append('flag', this.tipSpremembe);
      podatki.append('opis', this.opis);
      podatki.append('oznake', this.oznake);
      axios.post('./api/changelog/v2/vnos/', podatki, {withCredentials: true})
          .then((response) => {
            this.vnasam = !this.vnasam;
            this.types = "Uspešno";
            this.text = response.data.sporocilo;
            this.ShowNoti = true;
            this.verzija = '';
            this.datumSpremembe = null;
            this.naslovSpremembe = '';
            this.tipSpremembe = 'novo';
            this.opis = null;
            this.oznake = null;
            this.BeriVnose();
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        this.vnasam = !this.vnasam;
        this.types = "Napaka";
        this.text = "Prišlo je do napake pri vnosu zapisa";
        if(napaka.data.response.napaka) {
          this.text = napaka.data.response.napaka;
        }
        this.ShowNoti = true;
      });
    },
    PotrdiIzbris(id) {
      this.idIzbrisa = id;
      this.types = "Vprašanje";
      this.text = "Želite izbrisati izbran zapis?";
      this.ShowNoti = true;
    },
    BrisiZapis() {
      let podatki = new URLSearchParams();
      podatki.append('id', this.idIzbrisa);
      axios.post('./api/changelog/v2/brisi/', podatki, {withCredentials: true}).then((response) => {
        this.BeriVnose();
        this.idIzbrisa = null;
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        this.text = "Prišlo je do napake pri izbrisu zapisa"
        if(napaka.response.data.napaka) {
          this.text = napaka.response.data.napaka;
        }
        this.types = "Uspešno";
        this.ShowNoti = true;
      });
    }
  }
}
</script>

<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Vnos sprememb</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid p-3">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="text" :type="types" @closeNotification="ShowNoti = false" @da="BrisiZapis" @ne="ShowNoti = false" />
    </Transition>
  </div>

  <!-- VNOS -->

  <main class="content">

    <div class="page-header">

      <h1 class="text-white">Vnos sprememb aplikacije</h1>

    </div>


    <div class="editor">

      <section class="panel">

        <div class="panel-header">
          <div>
            <div class="panel-title">
              Podatki spremembe
            </div>

            <div class="panel-subtitle">
              Informacije, ki bodo prikazane v changelogu
            </div>
          </div>
        </div>


        <div class="panel-body">

          <div class="form-grid">

            <div class="field">

              <label>
                Verzija <span class="required">*</span>
              </label>

              <input
                  class="input-changelog"
                  type="text"
                  v-model="verzija"
                  placeholder="npr. v2.4.0"
              >

              <div class="hint">
                Verzija produkta, na katero se sprememba nanaša.
              </div>

            </div>

            <div class="field">

              <label>
                Datum <span class="required">*</span>
              </label>

              <input
                  class="input-changelog"
                  type="date"
                  v-model="datumSpremembe"
              >

            </div>

            <div class="field full">

              <label>
                Naslov <span class="required">*</span>
              </label>

              <input
                  class="input-changelog"
                  type="text"
                  v-model="naslovSpremembe"
                  placeholder="Kratek in jasen naslov spremembe"
              >

            </div>

            <div class="field full">

              <label>
                Tip spremembe <span class="required">*</span>
              </label>

              <div class="type-selector">

                <div class="type-option">
                  <input
                      class="input-changelog"
                      type="radio"
                      v-model="tipSpremembe"
                      value="novo"
                      id="new"
                      checked
                  >

                  <label
                      class="type-label"
                      for="new"
                  >
                    <i class="fas fa-star"></i>&nbsp; Novo
                  </label>
                </div>

                <div class="type-option">
                  <input
                      class="input-changelog"
                      type="radio"
                      v-model="tipSpremembe"
                      value="izboljsano"
                      id="improved"
                  >

                  <label
                      class="type-label"
                      for="improved"
                  >
                    <i class="fas fa-external-link-square-alt"></i>&nbsp; Izboljšano
                  </label>
                </div>

                <div class="type-option">
                  <input
                      class="input-changelog"
                      type="radio"
                      v-model="tipSpremembe"
                      value="popravljeno"
                      id="fixed"
                  >

                  <label
                      class="type-label"
                      for="fixed"
                  >
                    <i class="fas fa-check"></i> &nbsp; Popravljeno
                  </label>
                </div>

              </div>

            </div>

            <div class="field full">

              <label>
                Opis <span class="required">*</span>
              </label>

              <textarea v-model="opis"
                  placeholder="Opiši spremembo..."
              ></textarea>

              <div class="hint">
                Lahko uporabiš osnovno oblikovanje besedila.
              </div>

            </div>

            <div class="field full">

              <label>
                Oznake
              </label>

              <input
                  class="input-changelog"
                  type="text"
                  placeholder="npr. dashboard, analytics, ui"
                  v-model="oznake"
              >

              <div class="hint">
                Oznake loči z vejico.
              </div>

            </div>

          </div>


          <div class="form-footer">
            <button class="btn btn-primary" @click.prevent="DodajVnos()" :disabled="vnasam">
              Objavi spremembo <i class="fas fa-refresh fa-spin" v-if="vnasam"></i>
            </button>
          </div>

        </div>

      </section>

      <aside class="panel preview">

        <div class="panel-header">

          <div>
            <div class="panel-title">
              Vnosi
            </div>
          </div>

        </div>


        <div class="preview-area">

          <div class="preview-label">
            Dodane spremembe
          </div>


          <article v-for="vnos in vnosi" v-if="!berem">

            <div class="change mt-2" v-for="posamezen in vnos.spremembe">

              <div class="d-flex justify-content-between">
                <div class="badge">
                  {{ posamezen.naslov }}
                </div>
                <button class="btn btn-outline-danger" @click.prevent="PotrdiIzbris(posamezen.id)">
                  <i class="far fa-trash-alt"></i>
                </button>
              </div>
              <div class="text-white">
               <p class="hint">
                 {{ posamezen.opis }}
               </p>
              </div>

            </div>

          </article>
          <article v-else>
            <div class="change mt-2">
              <i class="fas fa-spinner fa-spin text-white"></i>
            </div>
          </article>

        </div>

      </aside>
    </div>
  </main>

</template>

<style>
:root {
  --bg: #121a21;
  --surface: #26333f;
  --surface-2: #202c37;
  --primary: #307acc;
  --primary-hover: #4088d6;

  --text: #f4f7fa;
  --muted: #94a3af;
  --border: rgba(255,255,255,.08);

  --success: #35b87f;
  --warning: #e5a83b;
  --danger: #d85d68;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: var(--bg);
  color: var(--text);
  font-family:
      Inter,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
}

/* BUTTONS */

button {
  border: 0;
  font-family: inherit;
  cursor: pointer;
}

.btn {
  height: 38px;
  padding: 0 15px;

  border-radius: 7px;
  font-size: 13px;
  font-weight: 600;
}
.editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(420px, .85fr);
  gap: 24px;
  align-items: start;
}
.btn-secondary {
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--border);
}

.btn-primary {
  color: white;
  background: var(--primary);
}

.btn-primary:hover {
  background: var(--primary-hover);
}

/* LAYOUT */

.content {
  width: min(1400px, calc(100% - 48px));
  margin: 0 auto;
  padding: 40px 0 70px;
}

.page-header {
  margin-bottom: 30px;
}

.breadcrumb {
  margin-bottom: 10px;
  color: var(--muted);
  font-size: 12px;
}

.page-header h1 {
  margin: 0;
  font-size: 30px;
  letter-spacing: -.8px;
}

.page-header p {
  margin: 8px 0 0;
  color: var(--muted);
  font-size: 14px;
}



/* PANELS */

.panel {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 18px 20px;
  border-bottom: 1px solid var(--border);
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: white;
}

.panel-subtitle {
  color: var(--muted);
  font-size: 12px;
}

.panel-body {
  padding: 22px;
}

/* FORM */

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field.full {
  grid-column: 1 / -1;
}

label {
  font-size: 12px;
  font-weight: 650;
  color: #dbe3e9;
}

.required {
  color: var(--primary);
}

input.input-changelog,
select,
textarea {
  width: 100%;
  color: var(--text);
  background: var(--surface-2);

  border: 1px solid var(--border);
  border-radius: 7px;

  outline: none;
  font-family: inherit;
  font-size: 13px;

  transition:
      border-color .2s,
      box-shadow .2s;
}

input.input-changelog,
select {
  height: 42px;
  padding: 0 12px;
}

textarea {
  min-height: 125px;
  padding: 12px;
  resize: vertical;
  line-height: 1.6;
}

input.input-changelog:focus,
select:focus,
textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(48,122,204,.12);
}

.hint {
  color: var(--muted);
  font-size: 11px;
}

/* TYPE SELECTOR */

.type-selector {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.type-option {
  position: relative;
}

.type-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.type-label {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 42px;
  padding: 0 10px;

  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 7px;

  color: var(--muted);
  font-size: 12px;
  font-weight: 650;

  cursor: pointer;
}

.type-option input:checked + .type-label {
  color: white;
  background: rgba(48,122,204,.15);
  border-color: var(--primary);
}

/* CHECKBOXES */

.options {
  display: flex;
  gap: 20px;
  padding-top: 3px;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 8px;

  color: var(--muted);
  font-size: 12px;
  cursor: pointer;
}

.checkbox input {
  width: 15px;
  height: 15px;
  accent-color: var(--primary);
}

/* FOOTER */

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  margin-top: 25px;
  padding-top: 20px;

  border-top: 1px solid var(--border);
}

/* PREVIEW */

.preview {
  position: sticky;
  top: 25px;
}

.preview-area {
  padding: 28px;
  background: #121a21;
}

.preview-label {
  margin-bottom: 20px;
  color: var(--muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.3px;
  text-transform: uppercase;
}

.release h2 {
  margin: 0 0 17px;
  font-size: 21px;
  letter-spacing: -.4px;
}

.change {
  padding: 17px;

  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 9px;
}

.badge {
  display: inline-flex;
  padding: 4px 8px;
  margin-bottom: 9px;

  border-radius: 5px;

  color: #77c9ff;
  background: rgba(48,122,204,.15);

  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
}

.change h3 {
  margin: 0 0 7px;
  font-size: 14px;
}

.change p {
  margin: 0;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.6;
}

/* TAGS */

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 14px;
}

.tag {
  padding: 5px 8px;
  color: #aebbc5;
  background: rgba(255,255,255,.05);
  border-radius: 5px;
  font-size: 10px;
}

/* RESPONSIVE */

@media (max-width: 900px) {
  .editor {
    grid-template-columns: 1fr;
  }

  .preview {
    position: static;
  }
}

@media (max-width: 600px) {
  .content {
    width: min(100% - 28px, 1400px);
    padding-top: 25px;
  }

  .topbar {
    padding: 0 15px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .field.full {
    grid-column: auto;
  }

  .type-selector {
    grid-template-columns: 1fr;
  }
}
</style>